var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "95A7E267-BCDA-430A-A3C1-FDA4BDE92B1D@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-774.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/returned",
    transform: "translate(774.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2C3C9",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8242188,17.25 C18.1341146,17.25 18.4075521,17.1315104 18.6445312,16.8945312 C18.8815104,16.6575521 19,16.3841146 19,16.0742188 L19,16.0742188 L19,7.92578125 C19,7.61588542 18.8815104,7.34244792 18.6445312,7.10546875 C18.4075521,6.86848958 18.1341146,6.75 17.8242188,6.75 L17.8242188,6.75 L9.07421875,6.75 C8.70963542,6.75 8.39973958,6.92317708 8.14453125,7.26953125 L8.14453125,7.26953125 L5,12 L8.14453125,16.7304688 C8.39973958,17.0768229 8.70963542,17.25 9.07421875,17.25 L9.07421875,17.25 L17.8242188,17.25 Z M15.2539062,14.9257812 L13.1757812,12.8203125 L11.0703125,14.9257812 L10.25,14.1054688 L12.3554688,12 L10.25,9.89453125 L11.0703125,9.07421875 L13.1757812,11.1796875 L15.2539062,9.07421875 L16.0742188,9.89453125 L13.9960938,12 L16.0742188,14.1054688 L15.2539062,14.9257812 Z",
    id: "\\uE14A",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturned);
export default __webpack_public_path__ + "static/media/returned.a2603c424b1e6f7ea1f43ad86a197521.svg";
export { ForwardRef as ReactComponent };